
import axios from 'axios';
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import BaseInfo from "../../BaseInfo.json";


let token, uploadHeader = { 'Content-type': 'multipart/form-data' }, header = {};
const url = BaseInfo.axiosUrl;
const baseUrl = url + "/api/v1/"
const baseUrlForUnAuthorize = url + "/"
const baseData = { "username": "WEB_APP", "password": "W#b@pp" }

/*<-----------AddHeder------->*/
export function AddHeader(key, value) {
    header[key] = value;
    uploadHeader[key] = value;
};
/*<-----------POST------->*/
export const GetToken = async (then, responseType = 'json') => {
    var options = {
        method: "POST",
        url: url + "/token",//baseUrl + customUrl,
        responseType: responseType,
        data: baseData,
        // params: params
    };
    const res = await axios(options);
    if (res.status === 200) {
        localStorage.setItem("manaBaseToken", res.data.token);
        localStorage.setItem("expirationDate", res.data.expirationDate);
        then(true);
    }
};
export const Post = async (customUrl, data, then, isAuth = true, responseType = 'json', forCaptcha) => {
    let minutes = 0;
    if (!!localStorage.getItem("expirationDate") && localStorage.getItem("expirationDate") != null && localStorage.getItem("expirationDate") != '') {
        let expireDate = localStorage.getItem("expirationDate").split('_')
        let today = new Date();
        let time = expireDate[1].split('-');
        let times = time[0] + ':' + time[1];
        let expire = new Date(expireDate[0] + ' ' + times);
        var diff = expire - today;
        minutes = Math.floor((diff / 1000) / 60);
    }
    if (minutes < 10) {
        var options = {
            method: "POST",
            url: url + "/token",//baseUrl + customUrl,
            responseType: responseType,
            data: baseData,
            // params: params
        };
        const res = await axios(options);
        if (res.status === 200) {
            localStorage.setItem("manaBaseToken", res.data.token);
            localStorage.setItem("expirationDate", res.data.expirationDate);
        }
    }
    if (!!forCaptcha && forCaptcha) {
        if (localStorage.getItem("manaBaseToken") === "" || localStorage.getItem("manaBaseToken") === null) {
            var options = {
                method: "POST",
                url: url + "/token",//baseUrl + customUrl,
                responseType: responseType,
                data: baseData,
                // params: params
            };
            const res = await axios(options);
            if (res.status === 200) {
                localStorage.setItem("manaBaseToken", res.data.token);
                const result = await axios(options).then(response => responseFunction(response, then)).catch((error) => errorAuthorized(error, then));
                return result;
            }
        }
        else {
            data.version = BaseInfo.appVersion
            var options = {
                method: "POST",
                url: url + "/" + customUrl,//baseUrl + customUrl,
                responseType: responseType,
                data: baseData,
                // params: params
            };
            const res = await axios(options).then(response => responseFunction(response, then)).catch((error) => errorAuthorized(error, then));
            return res;
        }
    } else if (isAuth) {
        if (localStorage.getItem("manaBaseToken") === "" || localStorage.getItem("manaBaseToken") === null) {
            var options = {
                method: "POST",
                url: url + "/token",//baseUrl + customUrl,
                responseType: responseType,
                data: baseData,
                // params: params
            };
            const res = await axios(options);
            if (res.status === 200) {
                localStorage.setItem("manaBaseToken", res.data.token);
                ApiRequestAuthorized1(res.data.token, customUrl, 'Post', data, null, responseType, then);
            }
        } else {
            await ApiRequestAuthorized(customUrl, 'Post', data, null, responseType, then);
        }
    }
    else {
        await ApiRequestUnauthorized(customUrl, 'Post', data, null, responseType, then)
    }
};
/*------Unauthorized Request------*/
function ApiRequestAuthorized1(token, customUrl, method, data, params, responseType, then) {
    !header.Authorization && AddHeader('Authorization', token);
    data.version = BaseInfo.appVersion;
    var options = {
        method: method,
        url: baseUrl + customUrl,
        headers: header,
        responseType: responseType,
        data: data,
        params: params
    }
    axios(options).then(response => responseFunction(response, then)).catch((error) => errorAuthorized(error, then));
};
/*<-----------POSTBLOB------->*/
export const PostBlob = async (customUrl, data, then, name, isAuth = true, responseType = 'blob') => {
    if (isAuth) {
        await ApiRequestAuthorizedBlob(customUrl, 'Post', data, null, responseType, then, name);
    }
    else {
        await ApiRequestUnauthorized(customUrl, 'Post', data, null, responseType, then)
    }
};
/*<-----------GET------->*/
export function Get(customUrl, params, then, isAuth = true, responseType = 'json') {

    ApiRequestAuthorizedForGet(customUrl, 'GET', null, params, responseType, then);
};


/*------Unauthorized Request------*/
function ApiRequestUnauthorized(customUrl, method, data, params, responseType, then) {
    data.token = localStorage.getItem("manaToken");
    var options = {
        method: method,
        url: url + "/token",//baseUrl + customUrl,
        responseType: responseType,
        data: data,
        params: params,
    };
    axios(options).then(response => responseFunction(response, then)).catch((error) => errorUnauthorized(error, then));
};
/*------errorUnauthorized------*/

const errorUnauthorized = async (error, then) => {
    if (error.response) {
        if (error.response.status === 403) {
            var options = {
                method: "POST",
                url: url + "/token",//baseUrl + customUrl,
                responseType: 'json',
                data: baseData,
                // params: params
            };
            const res = await axios(options);
            if (res.status === 200) {
                SetToken(res.data.token);
                localStorage.setItem("expirationDate", res.data.expirationDate);
            }
        } else if (error.response.status === 401) {
            // toast.error("عدم دسترسی به سرور");
            localStorage.removeItem("authentication");
            window.location.href = '/login'
        } else if (error.response.status === 400) {
            toast.error((error.response.data && error.response.data.message) ? error.response.data.message : "داده ارسالی صحیح نمی باشد");
            then({ suucess: false });
        } else {
            // toast.error("خطای برقراری ارتباط با سرور");
            then({ suucess: false });
        }
    }
};



/*------Authorized Request------*/
async function ApiRequestAuthorized(customUrl, method, data, params, responseType, then) {
    // if ((!token || token === '')) {
    //     window.location.href = '/login'
    // }
    !header.Authorization && AddHeader('Authorization', localStorage.getItem("manaBaseToken"));
    data.token = localStorage.getItem("manaToken");
    data.version = BaseInfo.appVersion;
    var options = {
        method: method,
        url: baseUrl + customUrl,
        headers: header,
        responseType: responseType,
        data: data,
        params: params
    }
    await axios(options).then(response => responseFunction(response, then)).catch((error) => errorAuthorized(error, then));
};
/*------Authorized Request------*/
async function ApiRequestAuthorizedForGet(customUrl, method, data, params, responseType, then) {
    var options = {
        url: baseUrlForUnAuthorize + customUrl,
        // + "/" + params,
        responseType: 'blob',
    }
    await axios(options).then(response => responseFunction(response, then)).catch((error) => errorAuthorized(error, then));
};
/*------Authorized Request------*/
async function ApiRequestAuthorizedBlob(customUrl, method, data, params, responseType, then, name) {
    // if ((!token || token === '')) {
    //     window.location.href = '/login'
    // }
    !header.Authorization && AddHeader('Authorization', localStorage.getItem("manaBaseToken"));
    data.version = BaseInfo.appVersion;
    var options = {
        method: method,
        url: baseUrl + customUrl,
        headers: header,
        responseType: responseType,
        data: data,
        params: params
    }
    await axios(options).then(response => responseFunctionBlob(response, then, name)).catch((error) => errorAuthorized(error, then));
};

function responseFunction(response, then) {
    if (response.status === 200) {
        var res = response.data;
        res.success = true;
        then(response.data);
    }
};
function responseFunctionBlob(response, then, name) {
    saveAs(response.data, name);
    if (response.status === 200) {
        var res = response.data;
        res.success = true;
    }
};

/*------errorAuthorized------*/
const errorAuthorized = async (error, then) => {
    if (error.response) {
        if (error.response.status === 403) {
            var options = {
                method: "POST",
                url: url + "/token",//baseUrl + customUrl,
                responseType: 'json',
                data: baseData,
                // params: params
            };
            const res = await axios(options);
            if (res.status === 200) {
                SetToken(res.data.token);
                localStorage.setItem("expirationDate", res.data.expirationDate);
            }
        } else if (error.response.status === 401) {
            // toast.error("عدم دسترسی به سرور");
            localStorage.removeItem("authentication");
            window.location.href = '/login'
        } else if (error.response.status === 400) {
            toast.error((error.response.data && error.response.data.message) ? error.response.data.message : "داده ارسالی صحیح نمی باشد");
            then({ success: false });
        } else {
            // toast.error("خطای برقراری ارتباط با سرور");
            if (then) {
                then({ success: false });
            }
        }
    }

};


/*<-----------SetToken------->*/
export function SetToken(tokenParam) {
    return new Promise((resolve, reject) => {
        if ((!tokenParam || tokenParam === '')) {
            window.location.href = '/login'
        }
        token = tokenParam;
        localStorage.setItem("manaBaseToken", tokenParam);
        AddHeader('Authorization', tokenParam ? tokenParam : localStorage.getItem("manaBaseToken"));
        resolve(true);
    });
}